
import {fetchClient} from "@/services/client";

const state = {
  clientData: {
    id: null,
    name: null,
  },
  availableClientList: []
}

const mutations = {
  setClient(state, payload) {
    state.clientData = payload
  },
  setAvailableClientList(state, payload) {
    state.availableClientList = payload;
  },
}

const getters = {
  client: function (state) {
    return state.clientData
  },
  availableClientList: function (state) {
    return state.availableClientList;
  }

}

const actions = {
  actionSetClient({commit}, id) {
    return new Promise((resolve, reject) => {
      fetchClient(id).then(response => {
        commit('setClient', response.data)
        resolve(response.data);
      }, error => {
        reject(error);
      })
    })
  },
  actionSetAvailableClientList({commit}, payload) {
    commit('setAvailableClientList', payload);
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
